import { useLocation } from "@for-it/web-lib";
import { useEffect } from "react";
import { logPageView } from "./google-analytics.ts";

export const RouteChangeTracker = () => {
    const location = useLocation();

    useEffect(() => {
        logPageView(location.pathname);
    }, [location]);

    return null;
};
